@if (barcodeValue) {
    @if (barcodeFormat === "QRCODE") {
        <div class="qr-barcode-wrapper">
            <qrcode
                [qrdata]="barcodeValue"
                [width]="256"
                [errorCorrectionLevel]="'M'"></qrcode>
            <pf-text type="subtitle">{{ barcodeValue }}</pf-text>
        </div>
    } @else {
        <ngx-barcode6
            [bc-value]="barcodeValue"
            [bc-display-value]="displayValue"
            [bc-format]="barcodeFormat"
            bc-text-align="center"
            [bc-height]="60"></ngx-barcode6>
    }
}
